module.exports = __webpack_public_path__ + "static/media/slide4Inactive.d0b8a951.png";